var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { getBEMClasses } from '../../helpers/cssClassesHelper';
import { buyValue, sellValue } from '../../constants/sendOrder/orderEntryFormConstants';
import ReportBlockTradeContainer from './ReportBlockTradeContainer';
import ConfirmBlockTradeModalContainer from '../ConfirmBlockTradeModal/ConfirmBlockTradeModalContainer';
import './ReportBlockTradeSidePaneComponent.css';
var baseClasses = getBEMClasses('report-block-trade-sidepane');
var ReportBlockTradeSidePane = function (_React$Component) {
  _inherits(ReportBlockTradeSidePane, _React$Component);
  function ReportBlockTradeSidePane() {
    _classCallCheck(this, ReportBlockTradeSidePane);
    return _possibleConstructorReturn(this, (ReportBlockTradeSidePane.__proto__ || Object.getPrototypeOf(ReportBlockTradeSidePane)).apply(this, arguments));
  }
  _createClass(ReportBlockTradeSidePane, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.onSidePaneOpen({
        title: this.context.t('Report Block Trade'),
        customClass: baseClasses(),
        classModifiers: 'with-tabs'
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
        form = _props.form,
        setBoughtReport = _props.setBoughtReport,
        setSoldReport = _props.setSoldReport,
        clearReportBlockTrade = _props.clearReportBlockTrade;
      var boughtTabModifier = (form && form.values.side === buyValue || !form) && 'bought-selected';
      var soldTabModifier = form && form.values.side === sellValue && 'sold-selected';
      var selectBoughtTab = function selectBoughtTab() {
        clearReportBlockTrade();
        setBoughtReport();
      };
      var selectSoldTab = function selectSoldTab() {
        clearReportBlockTrade();
        setSoldReport();
      };
      return React.createElement(React.Fragment, null, React.createElement('div', {
        className: baseClasses('tab-container')
      }, React.createElement('div', {
        className: baseClasses('tab', boughtTabModifier),
        onClick: selectBoughtTab
      }, this.context.t('Bought')), React.createElement('div', {
        className: baseClasses('tab', soldTabModifier),
        onClick: selectSoldTab
      }, this.context.t('Sold'))), React.createElement(ReportBlockTradeContainer, {
        useNewForm: get(this, 'props.useNewForm', false)
      }), React.createElement(ConfirmBlockTradeModalContainer, null));
    }
  }]);
  return ReportBlockTradeSidePane;
}(React.Component);
ReportBlockTradeSidePane.propTypes = {
  setBoughtReport: PropTypes.func.isRequired,
  setSoldReport: PropTypes.func.isRequired,
  form: PropTypes.object
};
ReportBlockTradeSidePane.defaultProps = {
  onSidePaneOpen: function onSidePaneOpen() {}
};
ReportBlockTradeSidePane.contextTypes = {
  t: PropTypes.func.isRequired
};
export default ReportBlockTradeSidePane;